import React from 'react';

import styled from 'styled-components';
import useTracking, { TrackingEventData } from '../../../hooks/useTracking';
import { EventNames } from '../../../utils/trackingEvents';
import { LinkCSS, LinkDecoration } from '../Link';
import { ButtonIconPosition } from '.';

const StyledLinkButton = styled.button<{ $decoration: LinkDecoration }>`
  ${LinkCSS}
`;

interface LinkButtonProps extends React.PropsWithChildren {
  decoration?: LinkDecoration;
  testId?: string;
  onClick?:
    | (() => void)
    | ((event: React.MouseEvent<HTMLButtonElement>) => void);
  iconPosition?: ButtonIconPosition;
  icon?: React.ReactNode;
  trackingData?: TrackingEventData & { eventName?: EventNames };
}

export const LinkButton: React.FC<LinkButtonProps> = ({
  children,
  decoration = LinkDecoration.All,
  testId,
  onClick,
  iconPosition = ButtonIconPosition.Left,
  icon,
  trackingData,
}) => {
  const { track } = useTracking();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
    if (trackingData) {
      const { eventName, ...restTrackingData } = trackingData;
      track(eventName ?? EventNames.ButtonClick, restTrackingData);
    }
  };

  return (
    <StyledLinkButton
      onClick={handleClick}
      data-testid={testId}
      type="button"
      $decoration={decoration}
    >
      {icon && iconPosition === ButtonIconPosition.Left && icon}
      {children}
      {icon && iconPosition === ButtonIconPosition.Right && icon}
    </StyledLinkButton>
  );
};
